import { useState, useEffect } from "react";

interface ObfuscatedContactProps {
  type: "email" | "phone";
  className?: string;
  children?: React.ReactNode;
}

/**
 * Obfuscates contact information to prevent spam bots from scraping
 * The actual value is constructed at runtime via JavaScript
 */
const ObfuscatedContact = ({ type, className = "", children }: ObfuscatedContactProps) => {
  const [contactInfo, setContactInfo] = useState<{ display: string; href: string } | null>(null);

  useEffect(() => {
    // Construct contact info at runtime to avoid bot scraping
    if (type === "email") {
      const user = "agent";
      const domain = "firststage";
      const tld = "ca";
      const email = `${user}@${domain}.${tld}`;
      setContactInfo({
        display: email,
        href: `mailto:${email}`,
      });
    } else if (type === "phone") {
      // Split phone number into parts
      const parts = ["613", "447", "7435"];
      const phone = parts.join("");
      const formatted = `(${parts[0]}) ${parts[1]}-${parts[2]}`;
      setContactInfo({
        display: formatted,
        href: `tel:+1${phone}`,
      });
    }
  }, [type]);

  if (!contactInfo) {
    // Show placeholder while loading (prevents layout shift)
    return (
      <span className={className}>
        {type === "email" ? "Loading..." : "Loading..."}
      </span>
    );
  }

  return (
    <a 
      href={contactInfo.href} 
      className={className}
    >
      {children || contactInfo.display}
    </a>
  );
};

export default ObfuscatedContact;
